import { render, staticRenderFns } from "./ChooseServiceMulti.vue?vue&type=template&id=6a0fdf8a&scoped=true"
import script from "./ChooseServiceMulti.vue?vue&type=script&lang=js"
export * from "./ChooseServiceMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0fdf8a",
  null
  
)

export default component.exports